/**
 * Input — shadcn/ui primitive (native `<input>` styled with design tokens).
 *
 * Lifted from the binding mockup at
 * `reignara_redesign/components/ui/input.tsx` and adapted to import the
 * project's `cn()` utility from `@/lib/utils`. Class strings consume design
 * tokens via Tailwind utilities only (`text-foreground`,
 * `text-muted-foreground`, `bg-primary`, `text-primary-foreground`,
 * `bg-input`, `border-input`, `ring-ring`, `border-destructive`); no hex /
 * `rgb(` / `hsl(` literals (Requirement 4.5).
 *
 * Feature: meridian-redesign
 * Requirements: 4.3, 4.4, 4.5
 */

import * as React from'react';

import { cn } from'@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>): JSX.Element {
 return (
 <input
 type={type}
 data-slot="input"
 className={cn(
'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input h-9 w-full min-w-0 rounded-input border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
'aria-invalid:ring-destructive/20 :ring-destructive/40 aria-invalid:border-destructive',
 className,
 )}
 {...props}
 />
 );
}

export { Input };
